import { render, staticRenderFns } from "./formulario-aptitud-fisica.vue?vue&type=template&id=3b2a889b&scoped=true"
import script from "./formulario-aptitud-fisica.vue?vue&type=script&lang=js"
export * from "./formulario-aptitud-fisica.vue?vue&type=script&lang=js"
import style0 from "./formulario-aptitud-fisica.vue?vue&type=style&index=0&id=3b2a889b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a889b",
  null
  
)

export default component.exports